import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterContentInit, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { isLoading } from '@core/interceptors/loading.interceptor';
import { SpaceService } from '@core/spaces/spaces.service';
import { UserService } from '@core/user/user.service';
import { IconsModule } from '@core/utils/icons.module';
import { UnsubscribeOnDestroy } from '@core/utils/unsubscribe-on-destroy.component';
import { distinctUntilChanged, filter, map, of, switchMap, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, MatProgressBarModule, CommonModule, IconsModule, FormsModule,
        ReactiveFormsModule],
})
export class AppComponent extends UnsubscribeOnDestroy implements AfterContentInit {
    private lastSavedUrl: string | null = null;
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _userService: UserService,
        private _spaceService: SpaceService,
    ) {
        super()
    }
    changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef)
    private _document = inject(DOCUMENT);

    ngOnInit(): void {
        this._router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this._router.url),
            distinctUntilChanged(),
            filter(url => url != '/home' && !["/forgot-password", "/sign-in", "/sign-up", "/reset-password"].find(u => url.includes(u))),
            switchMap(url => {
                if (url != this.lastSavedUrl) {
                    this.lastSavedUrl = url;
                    //console.log('Saving URL:', url);
                    return this._userService.saveUserLastVisitedURL(url);
                } else {
                    return of(null);
                }
            })
        ).subscribe();
        this._spaceService.setSpace('normal').subscribe()
    }

    loading = false
    
    
    ngAfterContentInit(): void {
        isLoading.pipe(
            takeUntil(this._unsubscribeAll),
            tap({
                next: (v) => {
                    if (this.loading != v) {
                        this.loading = v
                        if (!this.loading) {
                            this._document.body.classList.remove('waiting');
                        }
                        else {
                            this._document.body.classList.add('waiting');
                        }

                        this.changeDetectorRef.detectChanges()
                    }
                }
            })).subscribe()

    }




}
